<div class="card"
     [class.resume-card]="ticketEvent.eventType === 2">
    <i class="indicator fa"
        [class.fa-pause]="ticketEvent.eventType === 1"
        [class.fa-play]="ticketEvent.eventType === 2"
        [class.fa-check]="ticketEvent.eventType === 3"
        [class.fa-share]="ticketEvent.eventType === 4">
    </i>
    <div class="info">
        <div class="date">{{ ticketEvent.eventDate }}</div>
        <div class="subtext">
            <span *ngIf="ticketEvent.eventType === 1"
                 class="onEventText">{{ 'service.tickets.details.onEvent.pauseSubText' | translate }}
            </span>
            <span *ngIf="ticketEvent.eventType === 2"
                 class="onEventText">{{ 'service.tickets.details.onEvent.resumeSubText' | translate }}
            </span>
            <span *ngIf="ticketEvent.eventType === 3"
                 class="onEventText">{{ 'service.tickets.details.onEvent.rejectSubText' | translate }}
            </span>
            <span *ngIf="ticketEvent.eventType === 4"
                 class="onEventText">{{ 'service.tickets.details.onEvent.approveSubText' | translate }}
            </span>
            <span class="author">{{ authorName }}</span>
        </div>
    </div>
    <app-tooltip *ngIf="ticketEvent?.reason || ticketEvent?.description"
                 tooltipPosition="left"
                 [positionLeft]="-120"
                 type="info"
                 class="reason"
                 [record]="reasonText">
    </app-tooltip>
</div>
